import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../config/axios";
import { SECTORS } from "../../../config/sectors";
import Dashboardnavbar from "../../../layout/Dashboardnavbar";
import RopewaysProject from "./RopewayProjects";
import AddRopewayProject from "./AddRopewayProject";
import RopewaySections from "./RopewaySections";
import { AddProjectDetails } from "../ProjectDetailsCrud/ProjectDetailsCRUD";
import ProjectFilter from "../Projectname/ProjectFilter";
import SectionFilter from "../ProjectDetailsCrud/SectionFilter";

const SECTOR_ID = SECTORS.Ropeway.id;

const RopewayPage = () => {

    const [toggleState, setToggleState] = useState(1);
    const [buffer, setBuffering] = useState(false);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1: return "Ropeways Project Details";
            case 2: return "Ropeways Section Details";
            default: return "Project";
        }
    };

    const [projectName, setProjectName] = useState([]);

    const getProjectname = async (filters = null) => {
        setBuffering(true);
        try {
            let res;
            if (filters) {
                // Sector falls back to Ropeway so filtering never pulls in Highway/Railway projects.
                const url = `${BASE_URL}/dpr/projectdetailsmultiplefilter/${filters.project || "null"}/${filters.sector || SECTOR_ID}/${filters.workType || "null"}/${filters.companyName || "null"}/${filters.loaStartDate || "null"}/${filters.loaEndDate || "null"}/${filters.completionStartDate || "null"}/${filters.completionEndDate || "null"}/`;
                res = await axios.get(url);
            } else {
                res = await axios.get(`${BASE_URL}/dpr/projectdetailsfiltersector/${SECTOR_ID}/`);
            }
            setProjectName(res.data);
        } catch (err) { console.error("Ropeway project fetch failed:", err); }
        finally { setBuffering(false); }
    };

    const [project, setProject] = useState([]);

    const getProject = async (filters = null) => {
        setBuffering(true);
        try {
            let result;
            if (filters) {
                const safe = (val) => (val ? val : "null");
                const url = `${BASE_URL}/dpr/sectionmultiplefilter/${safe(filters.project)}/${safe(filters.section)}/${safe(filters.location)}/${safe(filters.workStage)}/${safe(filters.minLength)}/${safe(filters.maxLength)}/${safe(filters.minCost)}/${safe(filters.maxCost)}/`;
                result = await axios.get(url);
                // The backend section filter has no sector parameter, so keep only Ropeway sections here.
                setProject(result.data.filter((s) => s.sub_consultant === SECTOR_ID));
            } else {
                result = await axios.get(`${BASE_URL}/dpr/projectfiltersubconsultant/${SECTOR_ID}/`);
                setProject(result.data);
            }
        } catch (err) { console.error("Ropeway section fetch failed:", err); }
        finally { setBuffering(false); }
    };

    const handleProjectFilter = (filters) => getProjectname(filters);
    const handleSectionFilter = (filters) => getProject(filters);

    useEffect(() => { getProjectname(); }, []);
    useEffect(() => { getProject(); }, []);

    return (
        <>
            <div>
                <div>
                    <Dashboardnavbar name={getSelectedTitle()} url={"Project Management"} />
                </div>

                <div className="content-tabs">
                    <div className='toggle-button-area flex-row justify-between' style={{ padding: "15px 30px" }}>
                        <div className='flex-row justify-between' style={{ width: "100%" }}>
                            <div>
                                <button
                                    className={toggleState === 1 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
                                    onClick={() => setToggleState(1)}
                                >
                                    Ropeways Project Details
                                </button>
                                <button
                                    className={toggleState === 2 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading"}
                                    onClick={() => setToggleState(2)}
                                >
                                    Ropeways Section Details
                                </button>
                            </div>

                            {toggleState === 1 ?
                                <AddRopewayProject getProjectname={getProjectname} useFor="table" /> :
                                <AddProjectDetails getProject={getProject} project={project} ProjectDetails={projectName} usedFor="Ropeway" />
                            }
                        </div>
                    </div>

                    <div style={{ padding: "0 30px" }}>

                        {toggleState === 1 &&
                            <>
                                <ProjectFilter onApply={handleProjectFilter} hideSector={true} />
                                <RopewaysProject
                                    projectName={projectName}
                                    getProjectname={getProjectname}
                                    getProject={getProject}
                                    buffer={buffer}
                                    hideSector={true}
                                />
                            </>
                        }

                        {toggleState === 2 &&
                            <>
                                <SectionFilter onApply={handleSectionFilter} sectionData={project} />
                                <RopewaySections
                                    project={project}
                                    getProject={getProject}
                                    buffer={buffer}
                                    ProjectDetails={projectName}
                                    hideSector={true}
                                />
                            </>
                        }

                    </div>
                </div>
            </div>
        </>
    );
};

export default RopewayPage;